module.exports = __webpack_public_path__ + "static/media/Memb-I-00131_0042.9662633b.jpg";